import React from 'react';
import '../scss/Spinner.scss';

const Spinner = () => {
    return (
        <div className="enhanced-spinner-container">
        <div className="enhanced-spinner">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
        </div>
        </div>
    );
};

export default Spinner;